import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ViewportService } from '../services/viewport.service';

@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {
  constructor(
    private router: Router,
    private viewport: ViewportService
  ) {}

  canActivate(): boolean {
    if (this.viewport.shouldUseKilnListRoute()) {
      this.router.navigate(['/kiln-list']);
      return false;
    }
    return true;
  }
}
